// Module
var code = "<div class=\"widget-content relative doughnut-chart-widget\"> <wt-doughnut-chart class=\"fill\" component-id=\"{{'doughnut'+vm.item.guid}}\" data=\"vm.data\" options=\"vm.options\" ratio=\"vm.ratio\" series=\"vm.series\"> </wt-doughnut-chart> </div>";
// Exports
module.exports = code;